@use '@ingka/base/_mixins.scss' as *;
@use '@ingka/variables/style.scss' as *;

.menuModalBodyContainer {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  width: 100%;
  min-height: 80vh;
  background-color: $colour-elevation-2;

  & > * {
    grid-row: 1;
    grid-column: 1;
  }
}

.skapasModalBody {
  z-index: 9999999;
  padding-top: 0 !important;
}

.missingMenu {
  display: flex;
  flex-direction: column;
  gap: $space-150;
}

.missingMenuButtonGroup {
  display: flex;
  flex-direction: row;
  gap: $space-100;
}

.noPadding {
  padding-inline: 0;
}
